module.exports = __webpack_public_path__ + "static/img/out9.d33a0b2d.png";